import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface LatestAssetEvent extends AttributesMixin<typeof LatestAssetEvent> { }
@define
export class LatestAssetEvent extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assetsEvents/latest-event/');

    static attributes = {
        id: String,
        uid: String,
        assetId: Number,
        assetTypeId: Number,
        eventTypeId: Number,
        success: Boolean
    };
}
